import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import LongList from "../components/LongList";
import "rc-pagination/assets/index.css";
import "./styles/scss/Search.scss";
import { Request, catchErrorHandle, protypeObj } from "../common";

export default function App() {
	const { key } = useParams();
	const [hotNav, setHotNav] = useState("全部");
	const [list, setList] = useState([]);
	const [wjyzList, setWjyzList] = useState([]);
	const [renderList, setRenderList] = useState([]);

	useEffect(() => {
		const req = new Request({
			url: "/api/getProductList",
			data: {
				page: 1,
				pageSize: 100,
				service: "group",
				sort: "hot",
				product_name: key,
			},
		});

		const getData = async () => {
			try {
				const res = await req.send();

				if (res.status_code === 1000 && res.data?.data) {
					setList(res.data.data);
				}
			} catch (error) {
				console.log(catchErrorHandle(error));
			}
		};

		getData();

		return () => {
			req.cancel();
		};
	}, [key]);

	useEffect(() => {
		const req = new Request({
			url: "/open-platform/pro/productInfobywordWjyz",
			source: 1,
			data: {
				word: key,
			},
		});

		const getData = async () => {
			try {
				const res = await req.send();

				if (res.code === 200 && res.data?.data) {
					setWjyzList(res.data.data);
				}
			} catch (error) {
				console.log(catchErrorHandle(error));
			}
		};

		getData();

		return () => {
			req.cancel();
		};
	}, [key]);

	useEffect(() => {
		let arr = [];
		if (hotNav === "全部") {
			arr = [...list, ...wjyzList];
		} else if (hotNav === "共享游戏") {
			arr = [...list];
		} else {
			arr = wjyzList.filter((ele) => ele.protype === protypeObj[hotNav]);
		}

		setRenderList(arr);
	}, [hotNav, list, wjyzList]);

	return (
		<div className="main">
			<div className="search">
				<div className="head">
					<div className="left">
						{key && (
							<>
								搜索<span>“{key}”</span>如下相关结果
							</>
						)}
					</div>
					<div className="right">
						{["全部", "共享游戏", ...Object.keys(protypeObj)].map(
							(ele, index) => {
								return (
									<React.Fragment key={index}>
										<button
											type="button"
											className={hotNav === ele ? "active" : ""}
											onClick={() => {
												setHotNav(ele);
											}}
										>
											{ele}
										</button>
									</React.Fragment>
								);
							}
						)}
					</div>
				</div>
				<div className="content">
					<LongList list={renderList} search={true} />
				</div>
			</div>
		</div>
	);
}
